// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"e0-z","subtitle":"f0-z","wrapper":"g0-z","leftArrow":"h0-z","rightArrow":"i0-z"};